import { permissionType } from 'src/lib/utils/constants'

export type SwitchableTabType = {
  id?: string
  name: string
  label: string
  isActive: boolean
  childComponent?: string | JSX.Element
  permissionId?: typeof permissionType[keyof typeof permissionType]
  hideElement?: boolean
  showIndependentTab?: boolean
}

export type SearchParameterOptionsType = {
  value: string
  label: string
  placeholder: string
}

export type FileDataType = {
  name: string
  url: string
}

export type RadioItemConfigType = {
  label?: React.ReactNode
  description?: string
  valueType?: any
  isHidden?: boolean
  isDisabled?: boolean
  permissionId?: typeof permissionType[keyof typeof permissionType]
  endIcon?: React.ReactNode
  tooltipMessage?: string
}

export enum FeatureProfile {
  SHOPFLO = 'Shopflo',
  SHOPPASS = 'Shop-pass'
}

export interface IndianStateType {
  id: number
  countryCode: string
  name: string
  code: string
  metadata: any | null
}

export interface RatesConflictOptionsType {
  label : string , 
  valueType : string 
}